import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  EditButton,
  BulkDeleteButton,
  ReferenceField,
  FunctionField,
  usePermissions,
  Resource
} from "react-admin";
import { Box, Typography } from "@mui/material";


const UserGuideList = (props) => {
  console.log(Resource)
  const { permissions = [] } = usePermissions();
  

  return (
    
    <List title="User Guides" {...props}>
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          UserGuide
        </Typography>
      </Box>

      <Datagrid
        bulkActionButtons={
          permissions.includes("user-guides.delete") ||
          permissions.includes("user-guides.*") ||
          permissions.includes("*")
            ? <BulkDeleteButton />
            : false
        }
      >
        <TextField source="id" />
        <TextField source="title" />

        <ReferenceField source="course_id" reference="courses">
          <TextField source="course_name" />
        </ReferenceField>

        <BooleanField source="is_active" />
        <DateField source="created_at" />

        <FunctionField
          label="Action"
          render={() =>
            permissions.includes("user-guides.edit") ||
            permissions.includes("user-guides.*") ||
            permissions.includes("*")
              ? <EditButton />
              : null
          }
        />
      </Datagrid>
    </List>
  );
};

export default UserGuideList;